import { APPLICATION_CONFIG, AUTH_API_ROUTES } from "@constants/constants";
import axios from "axios";

interface HandoffExchangeResponse {
	active_token: string | null;
	refresh_token: string | null;
}

/**
 * Trades a one-time code issued by another zypl app for a session of this one.
 * Bare on purpose, like the refresh call: the code is the only credential, and
 * a rejected one must not reach the shared 401 handling, which would end a
 * session this browser may still hold.
 */
export const exchangeHandoffCode = async (
	code: string,
): Promise<HandoffExchangeResponse> => {
	const { data } = await axios.post<HandoffExchangeResponse>(
		`${APPLICATION_CONFIG.auth_url}${AUTH_API_ROUTES.HANDOFF_EXCHANGE}`,
		{ code },
		// The whole app waits on this; a stalled gateway ends in the usual
		// sign-in rather than a spinner with no way out.
		{ timeout: 10_000 },
	);

	return data;
};
